import type { ApolloCache } from '@apollo/client';
import { Apollo } from 'src/gql/generated';

/**
 * Puts a toolkit into the catalogue query the integrations page reads.
 *
 * Grant mutations return an `ExternalToolkit`, but that field is not the
 * `externalToolkits` list. Without this write the switches wait on a refetch.
 */
export function writeExternalToolkitCatalogue(
  cache: ApolloCache,
  toolkit: Apollo.ExternalToolkitSimpleFragment
): void {
  cache.updateQuery<Apollo.GetExternalToolkitsQuery>(
    { query: Apollo.GetExternalToolkitsDocument },
    current => {
      if (!current) return current;
      return {
        ...current,
        externalToolkits: current.externalToolkits.map(row =>
          row.slug === toolkit.slug ? toolkit : row
        ),
      };
    }
  );
}
